import helpers from '../helpers';

function openMenu() {
	return new Promise((resolve) => {
		$('.js-burger').addClass('is-disabled').attr('disabled', true);

		helpers.lockScroll(true, helpers.$header.find('.header__menu'), 'header');

		helpers.$header.addClass('is-menu-opened');

		setTimeout(() => {
			$('.js-burger').removeClass('is-disabled').attr('disabled', false);
			resolve();
		}, 100);
	});
}

function closeMenu() {
	return new Promise((resolve) => {
		$('.js-burger').addClass('is-disabled').attr('disabled', true);

		helpers.lockScroll(false, helpers.$header.find('.header__menu'), 'header');

		helpers.$header.removeClass('is-menu-opened');

		setTimeout(() => {
			$('.js-burger').removeClass('is-disabled').attr('disabled', false);
			$('.js-burger').removeClass('is-active');

			resolve();
		}, 500);
	});
}

function toggleMenu(event) {
	event.preventDefault();
	event.stopPropagation();

	if ($(event.currentTarget).hasClass('is-active')) {
		$(event.currentTarget).removeClass('is-active');
		closeMenu();
	} else {
		$(event.currentTarget).addClass('is-active');
		openMenu();
	}
}

function init() {
	helpers.$header = $('.header');

	$('.js-burger').on('click.header', toggleMenu);
	$('.close-menu').on('click.header', closeMenu);
}

export default {
	init,
	openMenu,
	closeMenu,
};
